<template>
  <div>
    <div id="cower" @click="codeHide()" v-show="iscode"></div>
    <div class="tipBox" v-show="iscode">
      <h3>
        <img src="../assets/logo.png" />
      </h3>
      <p>明医智APP扫描二维码进行登录</p>
      <p style="padding-top: 20px;">
        <qriously :value="initQCode" :size="300" />
      </p>
      <h6><a href="#">没有账号？立即下载</a></h6>
    </div>
    <transition name="my-trans">
      <div class="helpBox" v-show="show">
        <img src="../assets/help.png" />
      </div>
    </transition>
    <div class="headers" style="position: relative;">
      <header>
        <div class="logo">
          <img src="../assets/logo.png" />
        </div>
        <ul>
          <li>
            <router-link to="/">产品介绍</router-link>
          </li>
          <!-- <li>
            <router-link to="/News">新闻动态</router-link>
          </li> -->
          <li>
            <router-link to="/aboutUs">关于我们</router-link>
          </li>
          <li>
            <router-link to="/introduce">团队介绍</router-link>
          </li>
          <li>
            <router-link to="/contact">联系我们</router-link>
          </li>
        </ul>
        <span class="scodes" style="min-width: 136px;" @click="codeShow(); headerShow(); openselect()"
          v-bind:style="{ fontSize: myfont }"><img v-show="header" style="margin-right: 10px;vertical-align: super;"
            :src="userimg" /><i v-bind:style="{ width: iwidth }"
            style="display: inline-block;margin: 0 2px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap">{{
              loginTxt }}</i><img v-show="header"
            style="position: absolute;right: 10px;border-radius: 0;width: 7px;height: 7px;top: 42px;"
            src="../assets/385616900272080137.png" /></span>
        <div class="personageBox" v-show="isLogin">
          <ul>
            <router-link to="/uploadLive">
              <li>上传视频</li>
            </router-link>
            <router-link to="/openLive">
              <li>发起直播</li>
            </router-link>
            <li @click="loginOut()">退出</li>
          </ul>
        </div>
      </header>
    </div>
    <aside>
      <div class="leftBox">
        <ul>
          <li>
            <router-link to="/uploadLive">上传视频</router-link>
          </li>
          <li>
            <router-link to="">发起直播</router-link>
          </li>
        </ul>
      </div>
      <div class="rightBox">
        <dl>
          <dt><img src="../assets/live_tips.png" /></dt>
          <dd>
            <p>
              明医智项目直播需要您提前配备OBS直播软件，支持chrome、IE9以上、Firefox等浏览器
            </p>
            <p>
              需要您提前准备好： 摄像头、麦克风
            </p>
          </dd>
        </dl>
        <ul>
          <li>
            <p>视频标题</p>
            <input type="text" readonly="readonly" v-model="title" />
          </li>
          <li>
            <p>直播时间</p>
            <input type="text" readonly="readonly" v-model="time1" />
          </li>
          <li>
            <p>主播</p>
            <input type="text" readonly="readonly" v-model="stuname" />
          </li>
          <li>
            <p>直播简介</p>
            <textarea type="text" readonly="readonly" v-model="text" /></textarea>
          </li>
        </ul>
        <div style="padding: 30px 0;">
          <span class="openBt" @click="openLive()">开启直播</span><i class="jiaocheng">直播教程</i>
        </div>
        <div class="fottors">
          <a style="font-size: 18px;color: #666666;" href="https://www.miitbeian.gov.cn">Copyright © 2020-06-12 eagle soar
            . All Rights Reserved. 京ICP备18010429号</a>
        </div>
      </div>
    </aside>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "HelloWorld",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      iscode: false,
      show: false,
      isLogin: false,
      loginTxt: "扫码登陆",
      header: false,
      myfont: "20px",
      iwidth: "90px",
      initQCode: "",
      code: "",
      urltime: "",
      token: "",
      userimg: "",
      title: "",
      time1: "",
      stuname: "",
      text: "",
      id: "",
      openLiveBtn: false
    };
  },
  created: function () {
    this.headerShow();
    this.getData();
    this.codeShow();
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    $route: "getData"
  },
  methods: {
    loginOut() {
      localStorage.clear();
      this.$router.push({
        path: "/"
      });
      location.reload();
    },
    codeShow() {
      if (typeof localStorage.username != "undefined") {
        console.log(this.loginTxt);
        this.loginTxt = localStorage.username;
        this.userimg = localStorage.userimg;
        if (this.loginTxt != "扫码登陆") {
          this.myfont = "14px";
          this.iwidth = "55px";
          this.header = true;
          this.iscode = false;
          this.show = false;
          clearInterval(this.urltime);
          return;
        } else {
          this.getCode();
          this.iwidth = "55px";
          this.isLogin = false;
          this.iscode = true;
          this.show = true;
          this.urltime = setInterval(() => {
            this.getLogin();
          }, 5000);
        }
      }
    },
    openselect() {
      if (this.loginTxt != "扫码登陆") {
        this.isLogin = !this.isLogin;
      } else {
        this.getCode();
        this.iwidth = "90px";
        this.isLogin = false;
        this.iscode = true;
        this.show = true;
        this.urltime = setInterval(() => {
          this.getLogin();
        }, 5000);
      }
    },
    headerShow() {
      if (this.loginTxt != "扫码登陆") {
        this.myfont = "14px";
        //this.isLogin=!this.isLogin;
        this.header = true;
      }
    },
    codeHide() {
      this.iscode = false;
      this.show = false;
      clearInterval(this.urltime);
    },
    openLive() {
      //console.log(this.$refs.title.value);
      //console.log(this.id)
      //return
      if (this.openLiveBtn) {
        this.$router.push({
          path: "/OpenedLive",
          query: {
            nickNames: this.id
          }
        });
      }
    },
    getData() {
      let _this = this;
      this.$http
        .get("live/getLatelyLive.do?userId=" + localStorage.userid)
        .then(function (response) {
          console.log(response);
          if (response.status == 200) {
            if (response.data.data.live) {
              _this.openLiveBtn = true;

              _this.title = response.data.data.live.name;
              _this.time1 = response.data.data.live.starttimeStr;
              _this.stuname = response.data.data.live.stuname;
              _this.text = response.data.data.live.text;
              _this.id = response.data.data.live.id;
              if (response.data.data.live.start == 1) {
                localStorage.rtmpurl = response.data.data.live.rtmpurl;
                localStorage.livecode = response.data.data.live.livecode;
                localStorage.roomName = response.data.data.live.roomName;
                //_this.openLive();
              }
            }
            //alert('上传成功');
            //location.reload();

            //console.log(_this.id)
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getLogin() {
      console.log(11111);
      let _this = this;
      let qs = require("qs");
      let data = qs.stringify({
        code: _this.code
      });
      this.$http
        .post("checkQRCode.do", data)
        .then(function (response) {
          console.log(response);
          if (response.status == 200) {
            if (response.data.data.token != "") {
              clearInterval(_this.urltime);
              _this.loginTxt = response.data.data.username;
              _this.userimg = response.data.data.img;
              localStorage.username = response.data.data.username;
              localStorage.userimg = response.data.data.img;
              localStorage.userid = response.data.data.userid;
              token = response.data.data.token;
              _this.codeShow();
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getCode() {
      let _this = this;
      this.$http
        .get("getQR.do")
        .then(function (response) {
          console.log(response);
          if (response.status == 200) {
            _this.initQCode = response.data.data.code;
            _this.code = response.data.data.code
              .split("code=")[1]
              .split("&")[0];
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped>
/*头像*/
.personageBox {
  height: 254px;
  /*background: pink;*/
  width: 230px;
  position: absolute;
  right: 10px;
  background: #f9f9f9;
  z-index: 6;
}

.personageBox ul {
  float: none;
  margin-left: 0;
}

.personageBox ul li {
  height: 84px;
  font-size: 20px;
  color: #999999;
  text-align: center;
  line-height: 84px;
  border-bottom: 1px solid #ececec;
  float: none;
}

.personageBox ul li:nth-of-type(3) {
  border: none;
}

.scodes img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  vertical-align: middle;
}

/*over*/
.my-trans-enter-active,
.my-trans-leave-active {
  transition: all 0.5s ease-out;
}

.my-trans-enter {
  transform: translateX(-200px);
  opacity: 0;
}

.my-trans-leave-active {
  transform: translateX(1000px);
}

.helpBox {
  /*width: 580px;*/
  /*height: 590px;*/
  position: fixed;
  z-index: 10;
  /*background: #FFFFFF;*/
  left: 72%;
  top: 50%;
  /*margin-left: -290px;*/
  margin-top: -295px;
}

html,
body {
  height: 100%;
  width: 100%;
}

#cower {
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  z-index: 4;
}

.headers {
  border-bottom: 1px solid #ededed;
}

.tipBox {
  width: 580px;
  height: 592px;
  position: fixed;
  z-index: 10;
  background: #ffffff;
  left: 50%;
  top: 50%;
  margin-left: -290px;
  margin-top: -295px;
}

.tipBox h3 {
  width: 100%;
  text-align: center;
  padding: 40px 0 20px 0;
}

.tipBox p {
  font-size: 20px;
  color: #666666;
  text-align: center;
}

.tipBox p img {
  padding-top: 30px;
  width: 280px;
}

.tipBox h6 {
  font-size: 14px;
  padding-top: 20px;
  text-align: center;
}

.tipBox h6 a {
  color: #666666;
  font-weight: 400;
}

header {
  width: 1260px;
  height: 84px;
  margin: 0 auto;
  vertical-align: middle;
  padding-top: 20px;
  position: relative;
}

header img {
  width: 150px;
  height: 60px;
}

.logo {
  float: left;
}

header ul {
  float: left;
  margin-left: 120px;
}

header ul li {
  float: left;
  line-height: 60px;
  padding: 0 40px;
  font-size: 20px;
  color: #666666;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

header ul li:hover {
  color: #0075fc;
}

header ul li:nth-of-type(1) a {
  color: #0075fc;
}

.scodes {
  border-radius: 8px;
  width: 130px;
  height: 50px;
  display: inline-block;
  text-align: center;
  line-height: 50px;
  font-size: 20px;
  color: #ffffff;
  margin-left: 50px;
  background-image: linear-gradient(270deg, #fca36a 0%, #ec5e45 98%);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

aside {
  width: 1260px;
  margin: 0 auto;
  min-height: 500px;
  padding-top: 100px;
}

aside .leftBox {
  float: left;
}

aside .leftBox ul li {
  width: 230px;
  height: 84px;
  text-align: center;
  line-height: 84px;
  border: 1px solid #ebebeb;
  font-size: 20px;
}

aside .leftBox ul li a {
  color: #999999;
}

aside .leftBox ul li:nth-of-type(2) a {
  color: #666666;
}

.rightBox {
  width: 1026px;
  height: 1330px;
  float: right;
  border: 1px solid #ebebeb;
}

.rightBox dl {
  height: 140px;
  width: 920px;
  margin: 0 auto;
  padding-top: 40px;
}

.rightBox dl dt {
  float: left;
}

.rightBox dl dd {
  float: left;
}

.rightBox dl dd p {
  font-size: 18px;
  color: #666666;
  letter-spacing: -0.53px;
  line-height: 21px;
  padding-left: 30px;
}

.rightBox dl dd p:nth-of-type(1) {
  padding-bottom: 24px;
  padding-top: 24px;
}

.rightBox ul {
  width: 940px;
  padding: 10px 0;
  margin: 0 auto;
  border-bottom: 1px solid #ebebeb;
  border-top: 1px solid #ebebeb;
}

.rightBox ul li {
  padding: 20px 2px;
}

.rightBox ul li p {
  font-size: 20px;
  color: #666666;
  padding-bottom: 20px;
}

.rightBox ul li input {
  border: 1px solid #ebebeb;
  width: 910px;
  height: 62px;
  padding-left: 10px;
}

.rightBox ul li textarea {
  border: 1px solid #ebebeb;
  width: 910px;
  height: 140px;
  padding-left: 10px;
  padding-top: 10px;
  resize: none;
}

.rightBox .openBt {
  width: 150px;
  height: 60px;
  background-image: linear-gradient(270deg, #31cdf9 0%, #038cfd 98%);
  box-shadow: 0 4px 10px 0 rgba(0, 128, 254, 0.5);
  font-size: 20px;
  color: #ffffff;
  display: inline-block;
  text-align: center;
  line-height: 60px;
  margin-left: 44px;
  margin-right: 10px;
  border-radius: 8px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.jiaocheng {
  font-size: 14px;
  color: #fcba4c;
}

.fottors {
  font-size: 18px;
  color: #999999;
  text-align: center;
  line-height: 84px;
}
</style>



// WEBPACK FOOTER //
// src/pages/OpenLive.vue